import { ProductType, type Quote, type VanQuote } from "@/api_client";

const requiresMoreInformationForVan = (quote: Quote | undefined): boolean => {
  const vanQuote = quote as VanQuote | undefined;
  return !vanQuote?.vanDetails?.brand;
};

export const requiresMoreInformationToProceed = (
  productType: ProductType | undefined,
  quote: Quote | undefined,
): boolean => {
  if (productType === ProductType.VAN) {
    return requiresMoreInformationForVan(quote);
  }
  return false;
};
